export enum ISOCKET_ACTIONS {
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  DISCONNECT_CONVERSATION = 'disconnect-conversation',
  CONNECT_CONVERSATION = 'connect-conversation',
  MESSAGE_RECEIVED = 'message.chat-received',
}

export type ISOCKET_ON_TYPES = {
  CONNECT: ISOCKET_ACTIONS.CONNECT;
  DISCONNECT: ISOCKET_ACTIONS.DISCONNECT;
  MESSAGE_RECEIVED: ISOCKET_ACTIONS.MESSAGE_RECEIVED;
};

export type ISOCKET_EMIT_TYPES = {
  DISCONNECT_CONVERSATION: ISOCKET_ACTIONS.DISCONNECT_CONVERSATION;
  CONNECT_CONVERSATION: ISOCKET_ACTIONS.CONNECT_CONVERSATION;
};

type IValueOF<T> = T[keyof T];

export interface ISocket {
  on: <T>(name: IValueOF<ISOCKET_ON_TYPES>, cb: (id: T) => void) => void;
  emit: <T>(name: IValueOF<ISOCKET_EMIT_TYPES>, id: T) => void;
  disconnect: () => void;
}
